import type { IBuildLogLine } from '@/entities/build-live.entity';
import { cn } from '@/lib/utils';
import { useEffect, useRef, useState } from 'react';
import { Button } from '@/components/ui/button';

interface BuildLogViewerProps {
	lines: IBuildLogLine[];
	className?: string;
}

function getLineClass(stream: IBuildLogLine['stream']) {
	if (stream === 'stderr') return 'text-red-400';
	if (stream === 'log') return 'text-muted-foreground';
	return 'text-foreground/90';
}

export default function BuildLogViewer({ lines, className }: BuildLogViewerProps) {
	const containerRef = useRef<HTMLDivElement>(null);
	const [stickToBottom, setStickToBottom] = useState(true);

	useEffect(() => {
		if (!stickToBottom || !containerRef.current) return;
		containerRef.current.scrollTop = containerRef.current.scrollHeight;
	}, [lines, stickToBottom]);

	return (
		<div className={cn('rounded-xl border border-border overflow-hidden', className)}>
			<div className='flex items-center justify-between border-b border-border/60 bg-muted/30 px-3 py-2'>
				<p className='text-xs font-medium text-muted-foreground'>Логи сборки</p>
				<Button
					type='button'
					variant='ghost'
					size='sm'
					className='h-7 text-xs'
					onClick={() => setStickToBottom(value => !value)}
				>
					{stickToBottom ? 'Открепить скролл' : 'Автоскролл'}
				</Button>
			</div>
			<div ref={containerRef} className='max-h-[300px] overflow-auto bg-zinc-950 p-3 font-mono text-[11px] leading-5'>
				{lines.length === 0 ? (
					<p className='text-muted-foreground'>Ожидание логов…</p>
				) : (
					lines.map((line, index) => (
						<div key={`${line.ts}-${index}`} className={cn('whitespace-pre-wrap break-all', getLineClass(line.stream))}>
							{line.text}
						</div>
					))
				)}
			</div>
		</div>
	);
}
